import React, { useEffect } from 'react';
import { useUserContext } from '@blocs.auth';
import { ResumeSubscriptionBanner, TrialGlobalBanner, useBillingPopup } from '@blocs.paywall';
import { useRouter } from '@blocs.router';
import {
  hasArtistViewedHeadshotsPage,
  HeadshotsPromotionalBanner,
  rememberArtistViewedHeadshotsPage,
} from '@consumer-talent.components/Headshots/HeadshotsPromotionalBanner';
import { useHeadshotEligibility } from '@consumer-talent.components/Headshots/useHeadshotEligibility';
import { gqlSubscriptionStatusEnum } from '@minecraft.graphql-types';
import routeHelper from '../../routes/routeHelper';
import { useArtistContext } from './ArtistContext';

// One banner at a time: paused membership, then headshot booking, then the trial profile-ready banner.
const NavBanner = ({ hideNavigation }: { hideNavigation: boolean }) => {
  const { artistId, myAccount, subscription } = useUserContext();
  const { profileId } = useArtistContext();
  const billingPopup = useBillingPopup();
  const { pathname } = useRouter();
  const { canViewBookingPage, showHeadshotBanner } = useHeadshotEligibility();

  const isPausedSubscription = subscription?.status === gqlSubscriptionStatusEnum.PAUSED;
  const headshotsPath = routeHelper.headshots.link();
  const isOnHeadshotsPage = pathname === headshotsPath;
  const hasViewedHeadshotsPage = artistId != null && hasArtistViewedHeadshotsPage(artistId);
  const profileUrl = profileId ? routeHelper.profile.link({ profileId }) : undefined;

  useEffect(() => {
    // Wait until the account has loaded. A visit that is turned away is not a booking-page view.
    if (!myAccount || !canViewBookingPage || !isOnHeadshotsPage || artistId == null) {
      return;
    }

    rememberArtistViewedHeadshotsPage(artistId);
  }, [artistId, canViewBookingPage, isOnHeadshotsPage, myAccount]);

  if (isPausedSubscription) {
    return <ResumeSubscriptionBanner onClick={() => billingPopup.show({})} />;
  }

  if (!hideNavigation && showHeadshotBanner && !isOnHeadshotsPage && !hasViewedHeadshotsPage) {
    return <HeadshotsPromotionalBanner />;
  }

  return <TrialGlobalBanner subscription={subscription} artistId={artistId} profileUrl={profileUrl} />;
};

export default NavBanner;
